<script lang="ts">
  import * as Sheet from '$lib/components/ui/sheet';
  import { cn } from '@/lib/utils';
  import Button from '@/lib/components/ui/button/button.svelte';
  import type { Exercise } from '@/Common/ActivityFunctions';
  import ChooseTrainingView from './ChooseTrainingView.svelte';

  export let open: boolean;
  export let isLoading: boolean;
  export let originalExercises: Exercise[];
  export let sheetTitle: string;
  export let onConfirm: (exercise: Exercise) => void;
  export let actionButtonText: string = 'Select & Close';
  export let confirmButtonText: string | ((exercise: Exercise | null) => string) = 'Save';
  export let noExercisesFoundAdditionalInfo: string = '';

  let selectedExercise: Exercise | null = null;

  $: if (open) {
    selectedExercise = null;
  }

</script>

<Sheet.Root bind:open portal="#shadcn-ui-dialog-target">
  <Sheet.Content side="bottom" class={cn('flex flex-col gap-0 min-w-0 h-[95dvh]')}>
    <Sheet.Header class="border-b border-border pb-1">
      <Sheet.Title>
        {sheetTitle}
      </Sheet.Title>
    </Sheet.Header>

    <div class='h-full w-full flex flex-row gap-4 overflow-hidden'>
      <ChooseTrainingView
        {isLoading}
        {originalExercises}
        bind:selectedExercise
        {actionButtonText}
        {noExercisesFoundAdditionalInfo}
        onConfirm={(e) => {
          onConfirm(e);
          open = false;
        }}
      />
    </div>

    <Sheet.Footer class="border-t border-border pt-2 gap-2">
      <Button variant="outline" on:click={() => {
        open = false;
      }}>
        Close
      </Button>
      <Button variant="outline" type="submit" disabled={selectedExercise === null} on:click={() => {
        onConfirm(selectedExercise);
        open = false;
      }}>
        {typeof(confirmButtonText) === 'string' ? confirmButtonText : confirmButtonText(selectedExercise)}
      </Button>
    </Sheet.Footer>
  </Sheet.Content>
</Sheet.Root>
